import * as React from "react";

import "./credits.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {keyed}           from "@Common/react/keyed";
import {IndependentList} from "@Common/react/shadow/independent-list";
import {scn, scnv}       from "@Common/react/state-change-nested-value";
import {UseState}        from "@Common/react/use-state";
import {Checkbox}        from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {cnv}             from "@Common/utils/arr-path";
import {chain}           from "@Common/utils/fs";

import {groupEnrollmentEditors} from "../../../../../common/group-enrollment-editors";

export const Credits = ({initEnrollment, program, next}) => cs(
    consumeContext("company"),
    ["parts", ({company}, next) => IndependentList({
        list: [
            {
                path: "copay",
                label: "Copay",
                available: !!program.programPreferences.useCopay,
            },
            {
                path: "storecredit",
                label: "Store Credit",
            },
            {
                path: "adbudget",
                label: "Ad Budget",
                available: !!company?.prefs?.adBudgetEnable,
                fulfilling: true, // Maybe able to fulfill payment
            },
            {
                path: "voucher",
                label: "Voucher",
                available: !!company?.prefs?.enableVouchers,
                fulfilling: true, // Maybe able to fulfill payment
            },
        ]
            .map(({path, label, available, fulfilling}) => ({
                key: path,
                render: (next) => cs(
                    ["part", (_, next) => CreditPart({
                        initEnrollment, label, path, available: available ?? true, next,
                    })],
                    ({part}) => next({
                        ...part,
                        fulfilling,
                    })
                ),
            }))
        ,
        next: (list) => next(list.filter(v=>v)),
    })],
    ({parts}) => next({
        maybeFulfilled: parts.some((p) => p.fulfilling && p.selected), // Maybe able to fulfill payment
        enrollmentEditor: groupEnrollmentEditors(parts.map((p) => p.enrollmentEditor)),
        render: () => (
            <div {...{
                className: "payment-type credits-3n6",

                "xd-qa-type": "card",
                "xd-qa-name": "Credits",
            }}>
                <div className="header">
                    <div className="left">
                        <div {...{
                            className: "title",

                            "xd-qa-type": "label",
                            "xd-qa-name": "Credits",
                        }}>
                            Select Credit Types to apply at Checkout
                        </div>
                        {/*<div className="subtitle">*/}
                        {/*    Use Credits when available*/}
                        {/*</div>*/}
                    </div>

                </div>


                <div {...{
                    className: "message",
                    "xd-qa-type": "text",
                    "xd-qa-name": "Credits Description",
                }}>
                    If enabled, we'll use available funds to apply to the order total for each Edition. If you{" "}
                    don't have enough funds available in the selected Credit(s) to cover the order total,{" "}
                    the balance due for the Edition will be charged to your selected Payment Method.
                </div>


                <div className="box">
                    {/*{console.log("vouchers", vouchers)}*/}
                    {parts.map((p) => p.line).filter(v=>v).map(({key, label, selected, onClick}) => cs(
                        keyed(key),
                        () => (
                            <div className="line" onClick={onClick}>
                                <div className="left">
                                    <div className="selected-indicator">
                                        {Checkbox({
                                            checked: selected,

                                            xdQaName: label,
                                        })}
                                    </div>
                                    <div {...{
                                        className: "label",

                                        "xd-qa-type": "label",
                                        "xd-qa-name": label,
                                    }}>
                                        {label}
                                    </div>
                                </div>
                                {/*<div className="value">*/}
                                {/*    {formatMoney(value)}*/}
                                {/*</div>*/}
                            </div>
                        )
                    ))}
                </div>
            </div>
        ),
    }),
);

export const CreditPart = ({initEnrollment, label, path, available, next}) => cs(
    ["selected", (_, next) => UseState({
        getInitValue: () => chain(
            !available ? false : initEnrollment?.payment_options?.[path] ?? false,
            (_) => ({
                saved : _,
                current: _,
            })
        ),
        next,
    })],
    ({selected}) => next({
        selected: selected.value.current,
        enrollmentEditor: {
            valid: true,

            // loading: billingAccounts.loading,
            $name: "Credits " + label,
            prepareSave: (enrollment) => ({
                newValue: cnv(enrollment, ["payment_options", path], () => !available ? false : selected.value.current),
                onSaved: () => scn(selected, ["saved"], () => selected.value.current),
            }),
            changed: selected.value.current !== selected.value.saved,
        },
        line: !available ? null : {
            key: path,
            label,
            selected: selected.value.current,
            onClick: () => scnv(selected, ["current"], (_) => !_),
        },
    }),
);

